import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getTagRequest = {};
var _getTagResponse = { tag: '_tag' };
var _queryTagRequest = {};
var _queryTagResponse = { tags: '_tag' };
var _tag = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixDevcenterTagsV1TagsUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/tags',
                destPath: '',
            },
            {
                srcPath: '/tags',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/tags',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get a Tag by id */
export function getTag(payload) {
    var _a = serializer(_getTagRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTagResponse, { _tag: _tag }).fromJSON;
    function __getTag(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.prime.auto.v1.tag',
            method: 'GET',
            methodFqn: 'wix.devcenter.tags.v1.Tags.GetTag',
            url: resolveWixDevcenterTagsV1TagsUrl({
                protoPath: '/v1/tags/{tagId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTag.fromReq = fromReq;
    __getTag.__isAmbassador = true;
    return __getTag;
}
/** Query Tags using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryTag(payload) {
    var _a = serializer(_queryTagRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryTagResponse, { _tag: _tag }).fromJSON;
    function __queryTag(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.prime.auto.v1.tag',
            method: 'POST',
            methodFqn: 'wix.devcenter.tags.v1.Tags.QueryTag',
            url: resolveWixDevcenterTagsV1TagsUrl({
                protoPath: '/v1/tags/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryTag.fromReq = fromReq;
    __queryTag.__isAmbassador = true;
    return __queryTag;
}
//# sourceMappingURL=http.impl.js.map